/**
 * tournamentLink — the ONE durable, state-aware share link for a Puzzle Royale
 * tournament (P8).
 *
 * Points at the durable route `puzzle-royale-tournament/:id`, NOT at the chess
 * `CCTournaments?tournamentId=` route (different id space — skill.md pitfall
 * 34) and NOT at the ephemeral `?join=<share_code>` lobby link (that only
 * resolves while the race is live). The numeric id resolves at any lifecycle
 * stage, so a single link serves register → join → results.
 */

export function buildTournamentLink(
  tournamentId: number | string,
  origin?: string,
): string {
  const base =
    origin ??
    (typeof window !== 'undefined' && window.location
      ? window.location.origin
      : '');
  return `${base}/puzzle-royale-tournament/${encodeURIComponent(
    String(tournamentId),
  )}`;
}

/** Display title for a royale tournament: the host's custom name if set, else
 *  the durable "Puzzle Royale #<id>" fallback. One source of truth for rows +
 *  detail + header so a renamed tournament reads consistently everywhere. */
export function tournamentDisplayName(t: {
  id: number | string;
  name?: string | null;
}): string {
  const n = (t.name || '').trim();
  return n || `Puzzle Royale #${t.id}`;
}

export function copyToClipboard(text: string): boolean {
  try {
    if (typeof navigator !== 'undefined' && navigator.clipboard) {
      navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // swallow — caller shows a fallback
  }
  return false;
}
